<div class="infographic-container" [ngStyle]="{ 'border-color': backColor }" [ngClass]="{ small: smallInfographics }">
  <div class="infographics-column">
    <svg>
      <circle
        [attr.r]="radius"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke]="backColor"
        cx="27"
        cy="27"
      ></circle>
      <circle
        class="circle-animation"
        [attr.r]="radius"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="calcPercentage()"
        [attr.stroke]="foreColor"
        cx="27"
        cy="27"
        transform="rotate(-90 27 27)"
      ></circle>
    </svg>
    <div class="inforgraphic-icon" [ngClass]="getIcon()" [ngStyle]="{ color: foreColor }"></div>
  </div>
  <div class="status-column">
    <div class="inforgraphic-title" [ngStyle]="{ color: foreColor }">{{ title }}</div>
    <div
      class="inforgraphic-value"
      [ngStyle]="{ color: foreColor }"
      sa-ellipsis
      [fullText]="getStatus()"
      [placement]="'above'"
    ></div>
  </div>
</div>
